<template>
    <header class="appHeader">
        <div class="container d-flex align-items-center justify-content-between">
            <router-link to="/home" class="brand">
                <span class="brandMark">
                    <icon-buildings />
                </span>
                Brochure &amp; Magazine
            </router-link>
            <div class="userName" v-if="userName">{{userName}}</div>
        </div>
    </header>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { CommonServices } from '@/services/CommonServices';
import { getTokenClaim } from '@/utils';

@Options({})
export default class appHeader extends Vue {

    get userName(){
        return getTokenClaim(CommonServices.getAuthToken(), 'unique_name');
    }

}
</script>

<style scoped>
.appHeader {
    border-bottom: 1px solid #E8ECF1;
    background: #fff;
    padding: 14px 0;
}
.brand {
    display: flex;
    align-items: center;
    gap: 10px;
    font-weight: 700;
    font-size: 16px;
    color: #11142D;
    text-decoration: none;
}
.brandMark {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: #1E7EAA;
    color: #fff;
}
.userName {
    font-weight: 600;
    color: #5B6576;
}
</style>
